/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Open_In_Desktop_Fallback_MessageInputs */



/**
* | output |
* | --- |
* | "Nothing happened? Make sure the desktop app is installed and up to date." |
*
* @param {Open_In_Desktop_Fallback_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const open_in_desktop_fallback_message = /** @type {((inputs?: Open_In_Desktop_Fallback_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Open_In_Desktop_Fallback_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rien ne s'est passé ? Assurez-vous que l'application de bureau est installée et à jour.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ist nichts passiert? Stellen Sie sicher, dass die Desktop-App installiert und auf dem neuesten Stand ist.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non è successo nulla? Assicurati che l'applicazione desktop sia installata e aggiornata.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ничего не произошло? Убедитесь, что настольное приложение установлено и обновлено.")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿No ha pasado nada? Asegúrate de que la aplicación de escritorio esté instalada y actualizada.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("什么都没发生？请确保桌面应用程序已安装并保持最新版本。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("何も起こらなかった場合は、デスクトップアプリがインストールされ、最新の状態になっていることを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कुछ नहीं हुआ? सुनिश्चित करें कि डेस्कटॉप ऐप इंस्टॉल है और अपडेटेड है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não aconteceu nada? Verifique se o aplicativo para desktop está instalado e atualizado.")
	return /** @type {LocalizedString} */ ("Nothing happened? Make sure the desktop app is installed and up to date.")
});